import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {DepartmentsService} from '../../../../services/api/departments.service';

@Component({
    selector: 'app-component-departments-multiselect',
    templateUrl: './departments-multiselect.component.html',
    styleUrls: ['./departments-multiselect.component.scss'],
    animations: [
        trigger('fade', [
            state('in', style({opacity: 1, 'margin-top': '0px'})),
            transition(':enter', [style({opacity: 0, 'margin-top': '-15px'}), animate('0.1s ease-out')]),
            transition(':leave', animate('0.1s ease-out', style({opacity: 0, 'margin-top': '-15px'})))
        ])
    ]
})
export class DepartmentsMultiselectComponent implements OnInit, OnDestroy {
    public row: any = [];
    @Output() public value: EventEmitter<any> = new EventEmitter<any>();
    query: FormControl = new FormControl('');
    subscription: Subscription = new Subscription();
    selected = [];
    departments = [];
    select_open = false;
    @Input() private limit: number;
    @ViewChild('select_body') private select_body: ElementRef;
    @ViewChild('select_header') private select_header: ElementRef;

    constructor(
        protected departmentsApi: DepartmentsService
    ) {
    }

    @HostListener('document:click', ['$event'])
    AfterClick(event): void {
        if (
            this.select_body &&
            this.select_header &&
            !this.select_body.nativeElement.contains(event.target) &&
            !this.select_header.nativeElement.contains(event.target)
        ) {
            this.select_open = false;
        }
    }

    ngOnInit(): void {
        this.getDepartments();
        this.subscription = this.query.valueChanges
            .subscribe(next => {
                this.searchDepartment(next);
            });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    selectItems(item): any {
        let contains = false;
        if (this.selected.length) {
            this.selected.forEach((value, index) => {
                if (item.id === value.id) {
                    this.selected.splice(index, 1);
                    item.selected = false;
                    contains = true;
                    this.value.emit(this.selected.map(x => x.id));
                }
            });
        }
        if (!contains) {
            if (this.selected && this.selected.length >= this.limit) {
                this.select_open = false;
                return;
            }
            item.selected = true;
            this.selected.push(item);
            if (this.selected.length >= this.limit) {
                this.select_open = false;
            }
            this.value.emit(this.selected.map(x => x.id));
        }
    }

    searchDepartment(e): any {
        if (!e) {
            this.row = this.departments;
        }
        if (this.departments.length && e) {
            this.row = this.departments.filter(x => {
                if (x.name.toLowerCase().indexOf(e.toLowerCase()) > -1) {
                    return x;
                }
            });
        }
    }

    getDepartments(): any {
        this.departments = this.row = JSON.parse(sessionStorage.getItem('departments'));
        if (!this.departments || !this.departments.length) {
            this.departmentsApi.getDepartments().subscribe(data => {
                this.departments = this.row = data.departments;
            });
        }
    }

    selectedRow(): string {
        const data = this.selected.map(x => {
            return x.name;
        });
        return '<b>' + data.join(', ') + '</b>';
    }
}
